// extracted by mini-css-extract-plugin
module.exports = {"root":"📦TagAssetModal__root--1hTVf","scanner":"📦TagAssetModal__scanner--3RREZ"};